/* backup.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg width="24" height="24" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="foreground-gl" fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 5.9 5.9 1 12 1C18.1 1 23 5.9 23 12C23 12.4315 22.9755 12.857 22.9278 13.2751C22.0421 11.8687 20.6698 10.7996 19.0471 10.3041L17.2 8.7V10.0028C17.1336 10.0009 17.0669 10 17 10C13.134 10 10 13.134 10 17C10 17.0669 10.0009 17.1336 10.0028 17.2H8.7L10.3041 19.0471C10.7996 20.6698 11.8687 22.0421 13.2751 22.9278C12.857 22.9755 12.4315 23 12 23C5.9 23 1 18.1 1 12ZM15.3 6.8L12 3L8.7 6.8H10.6V9.6H13.4V6.8H15.3ZM3 12L6.8 15.3V13.4H9.6V10.6H6.8V8.7L3 12Z" fill="#5D6F80"/>
                <path class="foreground-gl" d="M15 13L19 13V17H22L17 22L12 17H15V13Z" fill="#5D6F80"/>
            </svg>

         `,
};
